import Head from 'next/head';
import { Box, Container, Tab, Card, Typography, Button } from '@mui/material';
import { ItemListResults } from '../list/list-results';
import { DashboardLayout } from '../dashboard-layout';

import {useState, useEffect} from 'react';

import {getItems, getRetailer} from '../Utils';

import {useAuth} from "../../contexts/AuthContext"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ItemCard from './ItemCard';
const db = app.firestore();

// ----------------------------------------

const LocationListTop = ({lastRefreshDate, setLastRefreshDate, toggleDrawer, ...rest}) => {

  const history = useHistory()

  const { retailerId } = useAuth();

  const [lastStockUpdateTime, setLastStockUpdateTime] = useState("");

  useEffect( () => {
    const loadRetailerAndSetInfo = async () => {
      const retailer = await getRetailer(retailerId);
      if(retailer.lastStockUpdateTime) {
        const lastDate = retailer.lastStockUpdateTime.toDate();
        setLastStockUpdateTime(lastDate.toLocaleDateString() + " - " + lastDate.toLocaleTimeString().replace(/(.*)\D\d+/, '$1'));
      }
    }
    loadRetailerAndSetInfo();
  }, [retailerId, lastRefreshDate]);

  return (
    <Box {...rest}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          m: -1
        }}
      >
        <Typography
          sx={{ m: 1 }}
          variant="h4"
          flexGrow={1}
        >
          Produits
        </Typography>
        <Typography
          sx={{ m: 1 }}
          variant="h6"
          flexGrow={1}
        >
          Dernière mise à jour : {lastStockUpdateTime}
        </Typography>
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setLastRefreshDate(new Date())}
          >
            Rafraichir
          </Button>
        </Box>
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            variant="contained"
            // onClick={() => history.push("/items/add")}
            onClick={toggleDrawer(true, "Ajouter un nouveau produit")}
          >
            Ajouter
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const attributes = {
  "SKU": "sku",
  "Nom": "name",
  "Quantité": "quantity",
  "Etat inventaire" : "stockState"
}

function LocationsGroupTable({emptyTitle, selectable, items, setLastRefreshDate, toggleDrawer, ...rest}) {
  const history = useHistory();
  const {currentUser} = useAuth();

  const bulkActions = [
    {
      title: "Supprimer",
      iconName: "eva:trash-2-outline",
      handler: async (ids) => {
        for(let id of ids) {
          await db.collection("items").doc(id).update({deleted: true, updatedBy: currentUser.email});
        }  
        // history.go("/items");
        setLastRefreshDate(new Date());
      }
    },
    {
      title: "Activer la notification SMS",
      iconName: "eva:bell-outline",
      handler: async (ids) => {
        console.log("activating sms for ...");
        for(let id of ids) {
          console.log("... "+id);
          await db.collection("items").doc(id).update({smsNotification: true, updatedBy: currentUser.email});
        }  
        // history.go("/items");
        setLastRefreshDate(new Date());
      }
    },
    {
      title: "Désactiver la notification SMS",
      iconName: "eva:bell-off-outline",
      handler: async (ids) => {
        for(let id of ids) {          
          await db.collection("items").doc(id).update({smsNotification: false, updatedBy: currentUser.email});
        }  
        // history.go("/items");
        setLastRefreshDate(new Date());
      }
    },
  ];
  
  const itemActions = [
    {
      title: "Modifier",
      iconName: "eva:edit-outline",
      // handler: (id) => history.push("/items/edit/"+id)
      handler: (id) => toggleDrawer(true, "Modifier les détails du produit", id, true)()
    },
    {
      title: "Dupliquer",
      iconName: "eva:copy-outline",
      // handler: (id) => history.push("/items/add/"+id)
      handler: (id) => toggleDrawer(true, "Ajouter un nouveau produit", id, false)()
    }
  ];

  const itemsById = {};

  for(let item of items) {
    itemsById[item.id] = item;
  }

  return (
    <ItemListResults
      items={items}
      attributes={attributes}
      bulkActions={bulkActions}
      itemActions={itemActions}
      filterFields={["name", "sku"]}
      selectable={selectable}
    />
  );
}

function LocationsFullPanel({lastRefreshDate, setLastRefreshDate, toggleDrawer}) {
  const { retailerId } = useAuth();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true); // todo handle loading.  

  const [value, setValue] = useState('1');

  const loadItems = async () => {
    console.log("loadItems called");
    try {      
      const newItems = await getItems(retailerId);
      setItems(newItems);
      setLoading(false);
    } catch(e) {
      console.log("error while loading items");
      console.log(e.message);
      setItems([]);
      setLoading(false);
    }
  }

  useEffect( () => {
    loadItems();
  }, [retailerId, lastRefreshDate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      {/* <Typography>{lastRefreshDate.toString()}</Typography> */}
      <Box sx={{ width: '100%', typography: 'body1' }}>        
        <LocationsGroupTable
          emptyTitle="Aucune boutique n'est enregistrée."
          items={items}
          selectable={true}
          toggleDrawer={toggleDrawer}
          setLastRefreshDate={setLastRefreshDate}
        />
      </Box>
    </Card>
  );
}

const Items = () => {
  const [lastRefreshDate, setLastRefreshDate] = useState(new Date());

  const [drawerState, setDrawerState] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  const [itemId, setItemId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false); // better name : isEdit

  const toggleDrawer = (open, title, itemId, isUpdate) => (event) => {
    // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    //   return;
    // }

    console.log("toggleDrawer called with : "+open+" "+title+" "+itemId);

    if(open) {
      setItemId(itemId);
      setIsUpdate(isUpdate);
    } else {
      setItemId(null);
      setIsUpdate(false);
    }

    if(open && title) {
      setDrawerTitle(title);
    }

    setDrawerState(open);
  };
  
  return (  
    <>
      <Head>
        <title>
          Produits
        </title>
      </Head>       
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <LocationListTop lastRefreshDate={lastRefreshDate} setLastRefreshDate={setLastRefreshDate} toggleDrawer={toggleDrawer} />
          <Box sx={{ mt: 3 }}>
            <LocationsFullPanel lastRefreshDate={lastRefreshDate} setLastRefreshDate={setLastRefreshDate} toggleDrawer={toggleDrawer}/>
          </Box>
          <ItemCard 
            itemId={itemId} 
            isUpdate={isUpdate} 
            setLastRefreshDate={setLastRefreshDate}
            drawerTitle={drawerTitle} 
            drawerState={drawerState} 
            toggleDrawer={toggleDrawer}/>
        </Container>
      </Box>
    </>
  );
}

Items.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default Items;
